module.exports = __webpack_public_path__ + "static/media/canadian-owned-mb-fr.b5632d7a.jpg";